function RedirectDropdown( el ) {
  var t = this;

  t.el = el;
  t.selects = ( el.tagName == 'SELECT' ) ? [el] : el.getElementsByTagName( 'select' );
  t.base = el.getAttribute( 'data-redirect-dropdown-base' );

  for ( var i = 0; i < t.selects.length; i++ ) {
    t.selects[i].addEventListener( 'change', function() {
      t.redirect(this);
    } );
  }
}

RedirectDropdown.prototype.redirect = function (select) {
  var url = this.base;

  if ( select.value !== '' && select.value !== 0 ) {
    url += select.value;
  }

  window.location.href = url;
};

module.exports = RedirectDropdown;